<template>
  <div class="tab-content d-flex justify-space-between align-start">
    <div class="tab-content-text d-flex flex-column ga-8">
      <div v-if="!isStable" class="alert-unstable-model px-4 py-2 rounded-lg italic">
        <p class="font-italic"><strong>Atenção!</strong> Você está usando uma versão experimental da IA, ou seja, a qualquer momento o assistente poderá mudar sua forma de agir/respostas conforme novas mudanças sejam adicionadas.</p>
      </div>
      <div class="d-flex flex-column ga-4">
        <h2 class="title-medium">Dados de integração:</h2>
        <div class="d-flex flex-column">
          <rb-autocomplete auto-select-first v-model="localData.channelSelected"
            label="Escolha o canal de integração do seu assistente *" :items="localData.channelList" item-title="nome" item-value="id"
            return-object :loading="localData.loading" :rules="props.inputRules.required" required>
          </rb-autocomplete>
        </div>
      </div>
      <div class="d-flex flex-column ga-2">
        <h2 class="title-medium">Escolha o modelo de linguagem</h2>
        <p class="body-medium">Modelos da linha Gemini oferecem diferentes combinações de velocidade, desempenho e qualidade. Flash e Flash
          Lite são otimizados para respostas rápidas, com baixa latência, ideais para interações ágeis. Já modelos como
          PRO e Thinking oferecem maior capacidade de raciocínio e geração de conteúdo, sendo mais indicados para
          tarefas complexas, ainda que com maior tempo de resposta.
          <a class="body-medium link" href="https://ai.google.dev/gemini-api/docs/models?hl=pt-br">Saiba mais</a>.
        </p>
        <div class="d-flex flex-column ga-4">
          <rb-select ref="selectModel" :rules="[...props.inputRules.modelInactive(localData.modelStatus), ...props.inputRules.required]" required label="Escolha o modelo de linguagem *" inline
            v-model="localData.model" :items="localData.allModels" :item-title="getItemTitle" item-value="id">
          </rb-select>
          <rb-select v-if="!isStable" required label="Escolha o modelo de linguagem secundário *" inline :rules="props.inputRules.required"
            v-model="localData.fallbackModel" :items="localData.stableModels" item-title="name" item-value="id" hint='Caso a versão experimental pare de funcionar, esse modelo será usado.'>
          </rb-select>
        </div>
      </div>
    </div>
    <CardBaseConhecimentos :relatedLinks="relatedLinks"></CardBaseConhecimentos>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref, watch } from 'vue';
import CardBaseConhecimentos from '@/assistents/components/CardBaseConhecimentos.vue';
const emit = defineEmits(['update:modelValue']);
const selectModel = ref(null);
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  relatedLinks: {
    type: Array,
    required: true
  },
  inputRules: {
    type: Object,
    required: true
  }
});

const localData = computed({
  get: () => props.modelValue,
  set: (newValue) => {
    emit('update:modelValue', newValue);
  }
});
const getItemTitle = (item) => {
  if (!item) return '';
  if (item.name && item.version) {
    return `${item.name} (Versão: ${item.version})`;
  }
  return item.name || '';
}


const isStable = computed(() => {
  if (!localData.value.model && localData.value.modelStatus) return true;
  return localData.value.stableModels.some(item => item.id === localData.value.model)
});

watch(()=> localData.value.modelStatus, (newValue) => {
  if (newValue === false) selectModel.value.validate();
})
</script>

<style lang='scss' scoped>
@use '@/ai_studio/styles/components/assistents-configuration.scss';
.alert-unstable-model{
  background-color: #FFB94666;
  color: #00000099;
  font-size: 14px;
  width: 100%;
  font-family: Roboto;
  text-align: left;
}

.v-radio-group :deep(.v-label) {
  margin-left: 8px;
}

.v-radio-group :deep(.v-selection-control--dirty .v-selection-control__input) {
  color: #00A1A1 !important
}

.v-radio-group :deep(.v-selection-control__input) {
  color: rgb(var(--v-theme-neutral-35));
}

.dados-integracao-content {
  .v-text-field ::v-deep .v-input__details{
    display: none;
  }
}
</style>
